import React from 'react';
import headerActions from '../../../../actions/header';

export default class MajorCategory extends React.Component {
  static propTypes = {
    id:       React.PropTypes.number,
    panel:    React.PropTypes.string,
    isActive: React.PropTypes.bool,
    name:     React.PropTypes.string
  };

  toggleCategory = (event) => {
    headerActions.toggleCategory(this.props.id, this.props.panel);
  };

  render () {
    const buttonClass = this.props.isActive
                    ? 'majorcategories__link is-active'
                    : 'majorcategories__link';

    const dataComponentName = this.props.isActive
                          ? 'activeMajorCategory'
                          : 'majorCategoryItem';

    return (
      <li className="majorcategories__item">
        <button
          className={buttonClass}
          onClick={this.toggleCategory}
          data-component={dataComponentName}>
          <span className="majorcategories__link__txt">{this.props.name}</span>
        </button>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/majorcategories/category/index.js